import { FormBase } from "../../util/form-base-form";

class UserSocialHandleCheckForm extends FormBase {
    public getRow(root: EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(root, ".master-url-check-row", HTMLElement);
    }

    public getFieldInput(root: ParentNode, field: string): HTMLInputElement | null {
        return this.queryElement(root, `input[name="${field}"]`, HTMLInputElement);
    }

    public getForm(root: EventTarget | Element | null | undefined): HTMLFormElement | null {
        return this.closest(root, "form", HTMLFormElement);
    }

    public getAllStatusIcons(root: ParentNode): HTMLElement[] {
        return this.queryElements(root, ".social-handle-check-status", HTMLElement);
    }
}

const userSocialHandleCheckForm = new UserSocialHandleCheckForm();

export { UserSocialHandleCheckForm, userSocialHandleCheckForm };
